<script setup lang="ts">
    import { columns } from '@/tables/columns/vat-deadlines';
    import { Head } from '@inertiajs/vue3';
    import { usePermissions } from '@/composables/usePermissions';
    import { useQuery } from '@tanstack/vue-query';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import CreateVatDeadline from '@/components/vat-deadlines/CreateVatDeadline.vue';
    import DataTable from '@/components/datatable/DataTable.vue';
    import DataTableToolbarActions from '@/components/datatable/DataTableToolbarActions.vue';
    import PageCard from '@/components/PageCard.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';
    import SystemCardMenu from '@/components/system/SystemCardMenu.vue';
    import type { BreadcrumbItem } from '@/types';

    const { hasPermission } = usePermissions();

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'menu.settings',
        },
        {
            title: 'menu.system',
            href: route('v2.vat-deadlines.index'),
        },
    ];

    const { isPending, isFetching, isError, data, error, refetch } = useQuery({
        queryKey: [QueryKey.VAT_DEADLINES],
        queryFn: getVatDeadlines,
    });

    async function getVatDeadlines() {
        const { data } = await axios.get(route('v2.vat-deadlines.table'));
        return data.data;
    }
</script>

<template>
    <Head :title="$t('system.vat_deadlines_title')" />

    <AppLayout :breadcrumbs="breadcrumbs">
        <PageCard>
            <DataTable
                :table-key="QueryKey.VAT_DEADLINES"
                :columns="columns"
                :data="data"
                :loading="isPending"
                :default-column-visibility="{
                    vat_deadline_id: false,
                }"
                :default-sorting="[{ id: 'vat_deadline_id', desc: true }]"
            >
                <template #title>
                    <SystemCardMenu />
                </template>
                <template #actions>
                    <DataTableToolbarActions name="vat-deadlines">
                        <CreateVatDeadline v-if="hasPermission(Permission.SYSTEM_CREATE)" />
                    </DataTableToolbarActions>
                </template>
            </DataTable>
        </PageCard>
    </AppLayout>
</template>
